<template>
  <CustomModal
    :is-modal-open="isOpen"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:w-[456px] tw:md:max-w-[calc(100vw-32px)] tw:md:h-[510px] tw:h-[100vh] tw:md:rounded-xl tw:rounded-none'"
    @toggleModal="requestClose">
    <template #modalHeader>
      <h2 class="tw:text-xl">{{ $t('description_remove_header') }}</h2>
    </template>

    <div class="tw:w-full">
      <p class="tw:mb-4">{{ $t('description_remove_subtext') }}</p>
      <div class="tw:rounded-lg tw:bg-gray-200 tw:p-4">
        <p class="tw:line-clamp-8 tw:text-start" :dir="previewTextDirection">
          {{ previewText }}
        </p>
      </div>
    </div>

    <template #modalFooter>
      <div class="tw:flex tw:w-full tw:justify-end tw:gap-4">
        <GhostButton size="big" class="tw:px-8 tw:py-2.5" :disabled="isRemoving" @click="requestGoBack">
          {{ $t('description_return') }}
        </GhostButton>
        <MainButton size="big" class="tw:px-8 tw:py-2.5" :disabled="isRemoving" @click="requestRemove">
          <span v-if="isRemoving">
            <SmallDotLoader color="#fff" />
          </span>
          <span v-else>{{ $t('description_remove_cta') }}</span>
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CustomModal from '@/components/base/CustomModal.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  previewText: {
    type: String,
    default: '',
  },
  previewTextDirection: {
    type: String,
    default: 'ltr',
  },
  isRemoving: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'goBack', 'remove'])

const requestClose = () => {
  if (props.isRemoving) {
    return
  }

  emit('close')
}

const requestGoBack = () => {
  if (props.isRemoving) {
    return
  }

  emit('goBack')
}

const requestRemove = () => {
  if (props.isRemoving) {
    return
  }

  emit('remove')
}
</script>
